import { request } from './request';
import { ApiConfigs, Response } from '../schemas/service';

const api: ApiConfigs = {
  queryhospitals: {
    url: '/health/api/v1/vaccine/hospitals',
    method: 'GET'
  },
  queryPickerData: {
    url: '/health/api/v1/vaccine/selector',
    method: 'GET'
  }
};

const service = {
  async queryhospitals(query) {
    try {
      const response: Response<any> = await request(api.queryhospitals, query);
      const { result } = response;
      return result;
    } catch (error) {
      return Promise.reject(error);
    }
  },
  async queryPickerData() {
    try {
      const response: Response<any> = await request(api.queryPickerData);
      const { result } = response;
      return result;
    } catch (error) {
      return Promise.reject(error);
    }
  }
};

export default service;
